import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { setName } from '../api';

/**
 * @param {import('react-query').UseMutationOptions} useMutationOptions
 * @returns {import('react-query').UseMutationResult}
 */
export default function useSetName(useMutationOptions) {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (variables) => dispatch(setName(variables)),
    ...useMutationOptions,
  });
}
